import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import LogoWatermark from './LogoWatermark';

const FooterCTA = () => {
  return (
    <section id="contact" className="section relative overflow-hidden" style={{ background: '#12367F', color: '#FFFFFF' }}>
      <div className="absolute inset-0 pointer-events-none opacity-[0.06]" style={{
        backgroundImage: 'radial-gradient(#2EF5FF 1px, transparent 1px)', backgroundSize: '22px 22px'
      }} />
      <LogoWatermark size={560} opacity={0.07} position="bottom-right" />
      <div className="container-x relative">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-2 w-2 rounded-full" style={{ background: '#2EF5FF' }} />
          <span className="text-xs md:text-sm uppercase tracking-[0.25em] font-medium text-white/70">
            Serving social-first success
          </span>
        </div>
        <h2 className="font-display uppercase text-balance max-w-5xl" style={{ fontSize: 'clamp(2.5rem, 8vw, 9rem)', lineHeight: 0.9 }}>
          Ready to <span style={{ color: '#2EF5FF' }}>connect?</span>
        </h2>
        <p className="mt-6 max-w-2xl text-white/80 text-base md:text-lg leading-relaxed">
          From managing talent and crafting game-changing creator strategies to producing
          scroll-stopping content, we offer end-to-end influencer marketing services Both UK and
          USA brands trust. Book a free strategy session to unlock the full potential of your next
          campaign.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <a href="/contact" className="btn-base btn-accent">
            Book a free strategy session <ArrowUpRight className="h-4 w-4" />
          </a>
          <a href="/services" className="btn-base btn-outline-light">
            Explore our services <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default FooterCTA;
